const Success = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>Your form has been submitted successfully.!</h1>
    </div>
  );
};

export default Success;
